import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body style={{ textAlign: "center", padding: "30px" }}>
        <h5>Are you sure?</h5>
        <p style={{ color: "#6b7280" }}>
          This action cannot be undone.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <Button className="bg-transparent text-dark border border-1" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            style={{ background: "red", border: "none" }}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;